import React, { useState } from 'react'
import { H4, Button, Intent, Dialog } from '@blueprintjs/core'
import DashboardElement from '../layout/dashboard-element/dashboard-element'
import PatientsTable from '../commons/patients-table/patients-table'
import patientsService from '../../api-services/patients-service'
import authenticationServices from '../../authentication-services'
import { useList } from '../custom-hooks/api-hooks'
import css from './patients.module.css'
import FlexRow from '../layout/flex-row/flex-row'
import PatientForm from './patient-form'
import CSVFileSelectorForm  from '../imports/csv-file-selector-form'

function Patients () {
  const [patients, setPatients] = useState()
  const [isDialogOpen, setDialogOpen] = useState(false)
  useList(patientsService, setPatients)
  const [isDialogFileSelector, setDialogFileSelector] = useState(false)

  const { role } = authenticationServices.authenticationData

  return (
    <div>
      <DashboardElement className={css.patientsTable}>
        <FlexRow style={{ justifyContent: 'space-between' }}>

        <FlexRow style={{ justifyContent: 'left' }}>
          <H4>All patients</H4>
        </FlexRow>
        <FlexRow style={{ justifyContent: 'right' , gap: '10px' }}>
          { (role === 'admin' || role === "pharmacy") && <Button intent={Intent.PRIMARY} variant='outlined' className={css.addButton} onClick={() => setDialogFileSelector(true)}>Import PackMap</Button>}
          { (role === 'admin' || role === "pharmacy") && <Button intent={Intent.PRIMARY} icon='plus' className={css.addButton} onClick={() => setDialogOpen(true)}>Add Patient</Button>}
        </FlexRow>

        </FlexRow>
        <PatientsTable patients={patients} />
        <Dialog
          isOpen={isDialogOpen}>
          <PatientForm setDialogOpen={setDialogOpen} role={role}/>
        </Dialog>
      </DashboardElement>
       <Dialog
        isOpen={isDialogFileSelector}>
        <CSVFileSelectorForm setDialogOpen={setDialogFileSelector} patient={null} role={role}/>
      </Dialog>
    </div>
  )
}

export default Patients
